import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

export const VideoGallery = () => {
    const galleryContainer  = [...document.querySelectorAll(".section")]
    if (galleryContainer.length) {
        galleryContainer.forEach(container => {
            let lg = lightGallery(container, {
                speed: 500,
                controls: true,
                download: false,
                counter: [...container.querySelectorAll('[data-lightbox]')].length > 1,
                appendCounterTo: '.lg-toolbar',
                prevHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none"><path d="M14.4519 28.8053L14.6287 28.9821L14.8055 28.8053L16.1169 27.4939L16.2937 27.3171L16.117 27.1404L5.15579 16.1767L31 16.1767L31.25 16.1767L31.25 15.9267L31.25 14.0704L31.25 13.8204L31 13.8204L5.15588 13.8204L16.1169 2.8593L16.2937 2.68253L16.1169 2.50575L14.8055 1.19432L14.6287 1.01754L14.4519 1.19432L0.823223 14.823L0.646446 14.9998L0.823223 15.1766L14.4519 28.8053Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/></svg>',
                nextHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none"><path d="M17.5481 1.26499L17.3713 1.08822L17.1945 1.26499L15.8831 2.57643L15.7063 2.75318L15.883 2.92996L26.8442 13.8936L0.999999 13.8936L0.749999 13.8936L0.749999 14.1436L0.749999 16L0.749999 16.25L0.999999 16.25L26.8441 16.25L15.8831 27.211L15.7063 27.3878L15.8831 27.5646L17.1945 28.876L17.3713 29.0528L17.5481 28.876L31.1768 15.2473L31.3536 15.0705L31.1768 14.8937L17.5481 1.26499Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/></svg>',
                /*defaultCaptionHeight: 250,*/
                getCaptionFromTitleOrAlt: true,
                licenseKey: '69080706-1AC0-46D4-92AC-34A021105012',
                zoom: false,

                mobileSettings: {
                    showCloseIcon: true
                },
                allowMediaOverlap: false,
                selector: '[data-lightbox]',
                autoplayVideoOnSlide: false,
                gotoNextSlideOnVideoEnd: false,
                plugins: [lgZoom, lgVideo]
            });



            container.addEventListener('lgHasVideo', (e) => {
                setTimeout(function () {
                    const youtube = document.getElementById('lg-youtube' + e.detail.index)
                    if (youtube) {
                        let youtubePlayer = new YT.Player('lg-youtube' + e.detail.index, {
                            events: {
                                'onStateChange': onYTPlayerStateChange
                            }
                        });
                    }

                    const vimeo = document.getElementById('lg-vimeo' + e.detail.index)
                    if (vimeo) {
                        let vimeoPlayer = new Vimeo.Player(vimeo);

                        vimeoPlayer.on('ended', function() {
                            lg.closeGallery()
                        });
                    }
                }, 2000);



            });

            function onYTPlayerStateChange(event) {
                if (event.data === YT.PlayerState.ENDED) {
                    lg.closeGallery();
                }
            }



        });
    }
}